import { IndexedDBConfig } from '@softline/core';
import { SOFTLINE_NAME_USER_INDEXED_DB } from '../softapps-core.shared';

export const SOFTLINE_NAME_PAGE_SETTINGS_OBJECT_STORE = 'page-settings';
export const SOFTLINE_NAME_LAST_USED_OBJECT_STORE = 'last-used';
export const SOFTLINE_NAME_FAVORITES_OBJECT_STORE = 'favorites';
export const SOFTLINE_NAME_TEMPLATES_OBJECT_STORE = 'templates';
export const SOFTLINE_NAME_QUERY_HISTORY_OBJECT_STORE = 'query-history';

export const SOFTLINE_INDEXED_DB_USER: IndexedDBConfig = {
  version: 1,
  name: SOFTLINE_NAME_USER_INDEXED_DB,
  objectStoreConfigs: [
    {
      name: SOFTLINE_NAME_PAGE_SETTINGS_OBJECT_STORE,
      parameters: { keyPath: 'name', autoIncrement: false },
      schema: [],
    },
    {
      name: SOFTLINE_NAME_FAVORITES_OBJECT_STORE,
      parameters: { keyPath: 'key', autoIncrement: false },
      schema: [],
    },
    {
      name: SOFTLINE_NAME_LAST_USED_OBJECT_STORE,
      parameters: { keyPath: 'key', autoIncrement: false },
      schema: [],
    }
  ],
};
